module.exports = __webpack_public_path__ + "static/zenimax-logo-black-ca496ecbe42d3cfaae30a5ab86389960.png";